import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { PavilionLogo } from './PavilionLogo';
export function Footer() {
  return <footer className="bg-foodCream pt-16 pb-8" data-id="element-41" data-mp="3ggty8ibanj58">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42" data-mp="32o4b2ak1486j">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-43" data-mp="32pp5m06cfr4e">
          <div className="md:col-span-2" data-id="element-44" data-mp="36q9354utwwr2">
            <a href="#" aria-label="The Food Pavilion, home" className="inline-block mb-4" data-id="element-45" data-mp="36n3bpiyq9is6">
              <PavilionLogo data-id="element-46" data-mp="3ucxs2ai99ph6" />
            </a>
            <p className="text-foodMaroon/80 font-medium max-w-sm mb-6" data-id="element-47" data-mp="38zbay6h7b62">
              A community food hub dedicated to creating pathways to prosperity
              for local culinary talent while bringing neighbors together.
            </p>
            <div className="flex gap-4" data-id="element-48" data-mp="3qblzbw434o4r">
              <a href="https://www.instagram.com/thefoodpavilionsf/" target="_blank" rel="noopener noreferrer" aria-label="Follow The Food Pavilion on Instagram" className="w-12 h-12 bg-foodMaroon text-foodCream flex items-center justify-center hover:bg-foodOrange transition-colors border-2 border-foodMaroon" data-id="element-49" data-mp="29ynnprb9nhh6">
                <Instagram size={24} data-id="element-50" data-mp="3v7zy1j4mj2od" />
              </a>
              <a href="#" aria-label="Email The Food Pavilion" className="w-12 h-12 bg-foodMaroon text-foodCream flex items-center justify-center hover:bg-foodOrange transition-colors border-2 border-foodMaroon" data-id="element-51" data-mp="3v5n92m0g7s1t">
                <Mail size={24} data-id="element-52" data-mp="33e4b4nsygpk" />
              </a>
            </div>
          </div>

          <div data-id="element-53" data-mp="hriflnkizpyb">
            <h4 className="font-extrabold uppercase text-xl mb-4" data-id="element-54" data-mp="hsa8gqmqn9kw">Explore</h4>
            <ul className="space-y-2 font-bold" data-id="element-55" data-mp="cus3fbbudei6">
              <li data-id="element-56" data-mp="cw36f8xgqi88">
                <a href="#popups" className="hover:text-foodOrange transition-colors" data-id="element-57" data-mp="qt04nvfwv1z5">
                  Biweekly Pop-Ups
                </a>
              </li>
              <li data-id="element-58" data-mp="tvw7qgxe1ffz">
                <a href="#workshops" className="hover:text-foodOrange transition-colors" data-id="element-59" data-mp="twfnbqzkfrqu">
                  Workshops
                </a>
              </li>
              <li data-id="element-60" data-mp="13rptmqwzylaf">
                <a href="#vendors" className="hover:text-foodOrange transition-colors" data-id="element-61" data-mp="13r7n91gmeqos">
                  Become a Vendor
                </a>
              </li>
              <li data-id="element-62" data-mp="1hkp60k1hfzdr">
                <a href="#partners" className="hover:text-foodOrange transition-colors" data-id="element-63" data-mp="1hk5yzyddevei">
                  Partner With Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-64" data-mp="1rid4nl27lr17">
            <h4 className="font-extrabold uppercase text-xl mb-4" data-id="element-65" data-mp="1rgsgqeaeh6cb">Visit Us</h4>
            <address className="not-italic font-medium text-foodMaroon/80 space-y-2" data-id="element-66" data-mp="3ocpz7n0aoa0c">
              <p data-id="element-67" data-mp="3tb19tzyeyojm">India Basin Waterfront Park</p>
              <p data-id="element-68" data-mp="2af3qfjjjwrgg">900 Innes Ave</p>
              <p data-id="element-69" data-mp="2afdm9nra1su2">San Francisco, CA 94124</p>
              <p className="pt-2 font-bold text-foodMaroon" data-id="element-70" data-mp="2ah84gub5z6ug">Operating Hours:</p>
              <p data-id="element-71" data-mp="25mu7ingusrno">Saturday & Sunday • 12 PM – 6 PM</p>
              <p className="pt-2 font-bold text-foodMaroon" data-id="element-72" data-mp="21mjy10turj42">
                Open Office Hours:
              </p>
              <p data-id="element-73" data-mp="1woi6rsm9wdhi">1st & 3rd Mondays • 5 PM – 7 PM</p>
            </address>
          </div>
        </div>

        <div className="border-t-4 border-foodMaroon pt-10 pb-10 flex flex-col items-center gap-6" data-id="element-74" data-mp="2te9dcq7u9r3o">
          <h4 className="font-extrabold uppercase text-sm tracking-widest text-foodMaroon/60" data-id="element-75" data-mp="2pc4i5n1qsmex">
            In Partnership With
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12" data-id="element-76" data-mp="2kfe5zat26ays">
            <img src="https://cdn.magicpatterns.com/uploads/2ZSi3AccgZnEUBmfgiuxMw/Untitled_design_(4).png" alt="San Francisco Recreation & Parks" className="h-24 w-auto object-contain" data-id="element-77" data-mp="2fdykjhmyy2fv" />
            <img src="https://cdn.magicpatterns.com/uploads/nYkbhZjohnn3Xbm3r4WWAs/Untitled_design_(5).png" alt="India Basin Waterfront Park, San Francisco" className="h-24 w-auto object-contain" data-id="element-78" data-mp="2rvzm7cez23t6" />
          </div>
        </div>

        <div className="border-t-4 border-foodMaroon pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-79" data-mp="2it8814upotxu">
          <p className="font-bold text-sm" data-id="element-80" data-mp="3bk029ws7v8ij">
            © {new Date().getFullYear()} The Food Pavilion. All rights
            reserved.
          </p>
          <div className="flex gap-4 text-sm font-bold" data-id="element-81" data-mp="3fkiu3qu40ekq">
            <a href="#" className="hover:text-foodOrange" data-id="element-82" data-mp="31m2fldq09js1">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-foodOrange" data-id="element-83" data-mp="36judqph8u24o">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}